import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";

import { SessionsFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkSessionsPOSTErrorResponse, ParkSessionsPOSTRequest, ParkSessionsPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchSessions = async (requestData: ParkSessionsPOSTRequest): Promise<ParkSessionsPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkSessionsPOSTSuccessResponse>("/sessions", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkSessionsPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: SessionsFailReason };
  }
};
